class EnvHelper {
  private _oem: OEM_TYPE = 'lenovo'

  public init() {}

  get extensionPrefix() {
    return 'huiyi_webapp'
  }

  get isProd() {
    return process.env.NODE_ENV === 'production'
  }

  get productName() {
    return 'AI翻译'
  }

  get host() {
    return process.env.REACT_APP_HOST
  }

  get webHost() {
    return process.env.REACT_APP_WEB_HOST
  }

  get apiHost() {
    return this.webHost
  }

  get apiBasePath() {
    return '/hy_lenovo_api'
  }

  get oem(): OEM_TYPE {
    return this._oem
  }

  public withExtensionPrefix(flagName: string) {
    return `ai-${flagName}`
  }
}

export const envHelper = new EnvHelper()
